import styled from 'styled-components';
import { Row } from 'antd';
import CustomCard from '@components/CustomCard';

export const ContainerRow = styled(Row)`
  margin-bottom: 16px;

  div.ant-typography {
    margin: 0;
    width: fit-content;
  }

  .ant-statistic-content {
    overflow: hidden;
  }
  .ant-badge {
    height: 100%;
    .ant-badge-status-dot {
      width: 14px;
      height: 14px;
    }
  }

  article {
    color: black !important;
    font-size: 4.5rem;
    background: white;
    text-align: center;
    font-weight: 600;
    padding: 50px 0;

    @media (max-width: 1650px) {
      font-size: 3rem;
    }

    @media (max-width: 800px) {
      font-size: 2rem;
    }

    @media (max-width: 500px) {
      font-size: 1.5rem;
      padding: 25px 0;
    }
  }

  h1 {
    color: black !important;
    font-size: 1rem;
    background: white;
    text-align: center;
    font-weight: 600;
    margin: 0;
    height: 40px;
    padding: 16px 4px 0;

    @media (max-width: 500px) {
      font-size: 0.8rem;
    }

    @media (max-width: 400px) {
      font-size: 0.6rem;
      padding-top: 8px;
    }
  }
`;

export const CardContainer = styled(CustomCard)`
  .ant-col {
    color: ${({ theme }) => theme.colors.text1};
  }

  .status-menu-display-items-container .ant-tabs-tab {
    cursor: default !important;
    border-color: ${({ theme }) => theme.colors.border} !important;
  }

  .card-title-row {
    width: 100%;

    @media (max-width: 620px) {
      justify-content: center;
    }
  }

  .card-title-name {
    @media (max-width: 375px) {
      white-space: break-spaces;
      text-align: center;
    }
  }

  .card-select-filter {
    @media (max-width: 375px) {
      width: 10rem !important;
    }
  }

  .card-title {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.text};

    .anticon-question-circle {
      svg {
        width: 1.2rem;
        height: 1.2rem;
        fill: ${({ theme }) => theme.colors?.text};
      }
    }

    .ant-tabs {
      padding: 0;
    }

    .ant-tabs-tab {
      margin: 0;

      .ant-tabs-ink-bar {
        padding: 20px;
      }
    }

    .ant-radio-group {
      z-index: 0;
    }

    .ant-radio-button-wrapper {
      margin: 0;
      flex-wrap: wrap;

      span {
        font-weight: normal;
      }
    }

    @media (max-width: 500px) {
      justify-content: center;

      .ant-radio-group {
        margin-top: 16px;
      }
    }
  }

  .total-value {
    color: ${({ theme }) =>
      theme.title === 'light' ? '#646E6E' : '#F0F5F5'} !important;
    margin-left: 8px;
    font-size: 0.7rem;
    opacity: 0.5;
    font-weight: 600;

    @media (max-width: 400px) {
      margin-left: 0px;
      text-align: center;
      width: 100%;
    }
  }

  .ant-card-body {
    padding: 16px;
    height: 100%;

    .ant-statistic {
      display: flex;
      flex-direction: column;
    }

    .ant-statistic-title {
      margin-bottom: 8px;
      font-weight: 500;
      font-size: ${({ theme }) => theme.fontSizes.small};
      color: ${({ theme }) => theme.colors.text1};
    }

    .ant-statistic-content {
      display: inline-flex;
      align-items: center;
    }

    .ant-statistic-content-value {
      color: ${({ theme }) => theme.colors.primary};
      font-size: ${({ theme }) => theme.fontSizes.large};
      line-height: ${({ theme }) => theme.fontSizes.large};
    }

    .ant-statistic-content-suffix {
      color: ${({ theme }) => theme.colors.text1};
      font-size: ${({ theme }) => theme.fontSizes.small};
      line-height: ${({ theme }) => theme.fontSizes.small};
    }
  }

  [data-chart-source-type='G2Plot'] {
    > div {
      z-index: 0;
    }
  }

  .g2-html-annotation {
    opacity: 0.8;
    font-size: 1.4rem !important;
    color: ${({ theme }) => theme.colors.text1} !important;
  }

  .g2-html-annotation + .g2-html-annotation {
    margin-top: 8px !important;
    font-size: 1.8rem !important;
    color: ${({ theme }) => theme.colors.text} !important;
  }
`;

export const FiltersContainer = styled.div`
  margin: 0 1.56rem 1.56rem;
  div {
    margin: 0;
  }
`;

export const DashboardCardContainer = styled(CustomCard)`
  .ant-card-body {
    margin-top: 40px;
  }
`;
